import React from "react";

function Close({color}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 12L8.00001 8.00001M8.00001 8.00001L4 4M8.00001 8.00001L12 4M8.00001 8.00001L4 12"
        stroke={color ? color : "#090D1D"}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default Close;
